import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
`;

export const Logo = styled.img`
  width: 100px;
  height: 100px;
`;

export const FormValidationError = styled(typography.TitleOneRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.redMain};
`;

export const FormBtn = styled(typography.BodyTextOneRegularTypography)`
  padding: 8px 40px;
  color: ${({ theme }) => theme.colors.white};
  background-color: ${({ theme }) => theme.colors.blueMain};
  border: 1px solid ${({ theme }) => theme.colors.blueMain};
  border-radius: 4px;
  cursor: pointer;

  ${({ disabled, theme }) =>
    disabled &&
    `
    background-color: ${theme.colors.grey300};
    border: 1px solid ${theme.colors.grey300};
  `}
`;
